// "Padrão"/"Standard" is how ICU names zones without daylight saving time;
// merchants say "Horário de Brasília", not "Horário Padrão de Brasília".
const STANDARD_WORD = /\s*\b(Padrão|Standard)\b/u;

/**
 * A timezone the way people say it ("Horário de Brasília", "Eastern Time")
 * instead of its IANA id; the id itself when the browser cannot name it.
 */
export function timezoneLabel(timezone: string, locale: string): string {
  try {
    const name = new Intl.DateTimeFormat(locale, {
      timeZone: timezone,
      timeZoneName: 'longGeneric',
    })
      .formatToParts(new Date())
      .find((part) => part.type === 'timeZoneName')?.value;
    return name ? name.replace(STANDARD_WORD, '') : timezone;
  } catch {
    return timezone;
  }
}

/** The city of an IANA id: "America/Sao_Paulo" → "Sao Paulo". */
export function timezoneCity(timezone: string): string {
  return (timezone.split('/').pop() ?? timezone).replace(/_/gu, ' ');
}
